import axios from 'axios';
import { getApiUrl, getApiMemedURL } from './config';

const api = axios.create({
  baseURL: `${getApiUrl(window.location.hostname)}/v1`,
});

export const apiMemed = axios.create({
  baseURL: `${getApiMemedURL(window.location.hostname)}/v1`,
});

export const memedReceita = axios.create({
  baseURL: `${getApiUrl(window.location.hostname)}/v1`,
});

/**
 * Intercepta as responses para formatar os dados
 * da API quando os dados forem retornados no padrão JSONAPI
 * */
api.interceptors.response.use((response) => {
  if (!response.data) {
    return response;
  }

  const { jsonapi } = response.data;

  // se o retorno da api for no padrão JSONAPI
  // formatamos os dados para deixar mais fácil
  // de trabalhar com eles
  if (jsonapi) {
    const { id, attributes } = response.data.data;

    // se existir ID e Attributes, fazemos um merge
    if (id && attributes) {
      response.data = {
        ...attributes,
        id,
      };
    }

    if (attributes) {
      response.data = attributes;
    }
  }

  return response;
});

export default api;
